import { BaseLayout } from "../layouts";
import { Container, InlineLink, NextPageWithLayout } from "@akte-mord/common";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { Typography } from "@mui/material";
import i18nConfig from "../../next-i18next.config";
import React from "react";
import type { GetStaticProps } from "next";

const SiteNotice: NextPageWithLayout = () => (
  <Container>
    <Typography variant="h1" sx={{ pb: 6 }}>
      Mentions légales
    </Typography>
    <Typography variant="body1" paragraph>
      Culinario Mortale® est une marque déposée de Bischoff, Kauffmann & Otani GbR.
    </Typography>
    <Typography variant="body1" paragraph>
      La distribution des titres est assurée par{" "}
      <InlineLink href="https://blackrockgames.fr/">Blackrock Games</InlineLink>. Pour les demandes des
      revendeurs, veuillez vous adresser à{" "}
      <InlineLink sx={{ hyphens: "none" }} href="mailto:commandes@blackrockgames.fr">
        commandes@blackrockgames.fr
      </InlineLink>
      .
    </Typography>
    <Typography component="h2" variant="h4" sx={{ pt: 4, pb: 1 }}>
      Informations selon § 5 TMG
    </Typography>
    <Typography variant="body1" paragraph>
      Bischoff, Kauffmann & Otani GbR
      <br />
      Hohenzollerndamm 152
      <br />
      14199 Berlin <br />
      Allemagne
    </Typography>
    <Typography variant="body1" paragraph>
      Bischoff, Kauffmann & Otani GbR est représentée par les associés gérants :
      <br />
      Florian Bischoff
      <br />
      Jens Kauffmann
      <br />
      Takeshi Otani
    </Typography>
    <Typography component="h2" variant="h4" sx={{ pt: 4, pb: 1 }}>
      Contact
    </Typography>
    <Typography variant="body1" paragraph>
      E-mail : mail@culinario-mortale.de
      <br />
      Téléphone: +49 (0) 30 25 29 21 51
    </Typography>
    <Typography component="h2" variant="h4" sx={{ pt: 4, pb: 1 }}>
      Le numéro de TVA intracommunautaire
    </Typography>
    <Typography variant="body1" paragraph>
      Numéro d'identification de la taxe sur le chiffre d'affaires conformément au §27a de la loi sur la
      TVA : DE288168520
    </Typography>
    <Typography component="h2" variant="h4" sx={{ pt: 4, pb: 1 }}>
      Responsable du contenu selon § 55 Abs. 2 RStV
    </Typography>
    <Typography variant="body1" paragraph>
      Bischoff, Kauffmann & Otani GbR
      <br />
      Florian Bischoff
      <br />
      Hohenzollerndamm 152
      <br />
      14199 Berlin
      <br />
      Allemagne
    </Typography>
    <Typography component="h2" variant="h4" sx={{ pt: 4, pb: 1 }}>
      Règlement des litiges
    </Typography>
    <Typography variant="body1" paragraph>
      La Commission européenne met à disposition une plate-forme pour le règlement en ligne des litiges
      (OS). Tu la trouveras sur{" "}
      <InlineLink href="https://ec.europa.eu/consumers/odr">
        https://ec.europa.eu/consumers/odr
      </InlineLink>
      .
    </Typography>
    <Typography variant="body1" paragraph>
      Notre adresse e-mail est mail@culinario-mortale.de.
    </Typography>
    <Typography variant="body1" paragraph>
      Nous ne sommes pas tenus de participer à une procédure de règlement des litiges devant un organisme
      de conciliation des consommateurs et ne sommes pas prêts à le faire.
    </Typography>
  </Container>
);

SiteNotice.getLayout = (page) => (
  <BaseLayout
    title="Mentions légales | Cold Case®"
    description="Mentions légales et informations juridiques obligatoires pour www.cold-case.fr"
    noindex={true}
    nofollow={true}
  >
    {page}
  </BaseLayout>
);

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(locale
        ? await serverSideTranslations(locale, ["c-common", "c-user-consent-management"], i18nConfig)
        : {}),
    },
  };
};

export default SiteNotice;
